const addToCart = (product) => {
    const button = document.querySelector(`#add-to-cart-${product}`);
    const variant_id = button.querySelector('input[name="id"]').value;
    const selling_plan = button.querySelector('input[name="selling_plan"]') ? button.querySelector('input[name="selling_plan"]').value : null;
    
    const qty = document.getElementById(`qty-${product}`) ? document.getElementById(`qty-${product}`).value : 1;

    const addData = {
        id: variant_id,
        quantity: qty,
        selling_plan: selling_plan,  // Include selling plan in the payload
    };

    fetch("/cart/add.js", {
        body: JSON.stringify(addData),
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
    })
    .then(response => response.json())
    .then(json => {
        goCart.fetchAndOpenCart();
    })
    .catch(err => {
        console.error(err);
    });
}

const addToCartinPLP = (product, secID) => {
    const button = document.querySelector(`#${secID}-add-to-cart-${product}`);
    const variant_id = button.querySelector('input[name="id"]').value;
    const selling_plan = button.querySelector('input[name="selling_plan"]') ? button.querySelector('input[name="selling_plan"]').value : null;
    
    const qty = document.getElementById(`${secID}-qty-${product}`) ? document.getElementById(`${secID}-qty-${product}`).value : 1;

    const addData = {
        id: variant_id,
        quantity: qty,
        selling_plan: selling_plan,  // Include selling plan in the payload
    };

    fetch("/cart/add.js", {
        body: JSON.stringify(addData),
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
    })
    .then(response => response.json())
    .then(json => {
        goCart.fetchAndOpenCart();
    })
    .catch(err => {
        console.error(err);
    });
}

const addToCartinPLP2 = (product, secID) => {
    const button = document.querySelector(`#${secID}-add-to-cart-${product}`);
    const variant_id = button.querySelector('input[name="id"]').value;
    const selling_plan = button.querySelector('input[name="selling_plan"]') ? button.querySelector('input[name="selling_plan"]').value : null;
    
    const qty = document.getElementById(`${secID}-qty-${product}`) ? document.getElementById(`${secID}-qty-${product}`).value : 2;

    const addData = {
        id: variant_id,
        quantity: qty,
        selling_plan: selling_plan,  // Include selling plan in the payload
    };

    fetch("/cart/add.js", {
        body: JSON.stringify(addData),
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
    })
    .then(response => response.json())
    .then(json => {
        goCart.fetchAndOpenCart();
    })
    .catch(err => {
        console.error(err);
    });
}